export const iconFontAwesomeMapsLocationArrow = (
	<i className="fa-solid fa-location-arrow"></i>
);
